export enum AwardApprovalType {
    NoApproval = 1,
    RequiresApproval = 2,
}